/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Form_DescriptionInputs */



/**
* | output |
* | --- |
* | "Give the agent its instructions, then point it at the knowledge it may use." |
*
* @param {Agent_Builder_Form_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_form_description = /** @type {((inputs?: Agent_Builder_Form_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Form_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie dem Agenten seine Anweisungen und legen Sie fest, welches Wissen er nutzen darf.")
	return /** @type {LocalizedString} */ ("Give the agent its instructions, then point it at the knowledge it may use.")
});